module.exports = __webpack_public_path__ + "img/julie.dc509a4e.jpg";